// @flow

import type { AssetOperation, AssetOperationsById } from 'fc-operator-asset/types'

// Constants
import { DELETE } from './../constants'

// Libs
import React, { Component } from 'react'
import _map from 'lodash/map'
import _some from 'lodash/some'
import _size from 'lodash/size'

// Components
import EditAsset from './EditAsset'
import Button from '@react-mdc/button'
import FormField from '@react-mdc/form-field'

// Styles
const styles = {
  container: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 300,
    backgroundColor: '#fff',
    color: '#fff',
    boxShadow: '-2px 0 2px rgba(0, 0, 0, 0.2)',
    padding: 15,
    overflow: 'auto',
  },
  paragraph: {
    marginBottom: 10,
  },
}

type Props = {
  operations: AssetOperationsById,
  farmSelectorOptions: Array<{ value: number, label: string }>,
  seasonSelectorOptions: Array<{ value: number, label: string }>,
  selectedFarmId: number,
  growerId: number,
  onChange: Function,
  onCancel: Function,
  onSubmit: Function,
}

export default class EditAssets extends Component {
  props: Props
  onSubmit: Function
  onCancel: Function

  constructor(props: Props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  onSubmit(e: Event) {
    e.preventDefault()

    this.props.onSubmit(this.props.operations)
  }

  onCancel(e: Event) {
    e.preventDefault()

    this.props.onCancel(this.props.operations)
  }

  renderOperations(): Array<React.Element<any>> {
    return _map(this.props.operations, (operation: AssetOperation): React.Element<any> => {
      return (
        <EditAsset
          key={operation.operationId}
          operation={operation}
          farmSelectorOptions={this.props.farmSelectorOptions}
          seasonSelectorOptions={this.props.seasonSelectorOptions}
          onChange={this.props.onChange}
          growerId={this.props.growerId}
          selectedFarmId={this.props.selectedFarmId}
        />
      )
    })
  }

  render(): ?React.Element<any> {
    if (_size(this.props.operations)) {
      const isDeleting = _some(this.props.operations, (o: AssetOperation): boolean => o.operation === DELETE)
      return (
        <form style={styles.container} onSubmit={this.onSubmit}>
          {isDeleting && (
            <FormField>
              <div>
                <div style={styles.paragraph}>Are you sure you want to delete the following?</div>
                <div style={styles.paragraph}>
                  Note that if you delete a farm with fields, the fields will also be deleted, along with any jobs
                  attached to those fields.
                </div>
              </div>
            </FormField>
          )}
          {this.renderOperations()}
          <Button raised primary onClick={this.onSubmit}>
            {isDeleting ? 'Confirm' : 'Submit'}
          </Button>
          <Button raised primary onClick={this.onCancel}>
            {'Cancel'}
          </Button>
        </form>
      )
    }

    return null
  }
}
